var $bf36dae9ecc81ce0$exports = {};
$bf36dae9ecc81ce0$exports = {
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Valitse kohde`,
    "tableResizer": `Koon muuttaja`
};


export {$bf36dae9ecc81ce0$exports as default};
//# sourceMappingURL=fi-FI.module.js.map
